"use client";
import { isWorkplaceRequestsEnabled } from "@gettactic/helpers/src/featureFlags";
import { WorkplaceRequestReserveFormData } from "@gettactic/helpers/src/reserve/mapWorkplaceRequestToReserveFormData";
import { useOrgFeatureFlag } from "@gettactic/hooks";
import React from "react";
import { useReserveForm } from "@/features/reserve/components/Reserve/ReserveFormProvider";
import { WPRequests } from "@/features/workplace-requests/components/WPRequests";
import { reservationWhenFromReserveForm } from "@/features/workplace-requests/lib/reservationWhen";
import type { NewRequestResourceContext } from "@/features/workplace-requests/views/queue/NewRequestWizard";
import { WorkplaceRequestsRef } from "@/types/workplace-requests";

export interface ReserveFormWPRequestsProps {
  workplaceRequestItems?: WorkplaceRequestReserveFormData[];
}

export const ReserveFormWPRequests: React.FC<ReserveFormWPRequestsProps> = ({
  workplaceRequestItems
}) => {
  const {
    office,
    wpRequestsRef,
    form,
    setCurrentBufferSettings,
    currentResource,
    floors
  } = useReserveForm();

  const workplaceRequestsFeatureFlag = useOrgFeatureFlag("workplace_requests");
  const shouldShow = isWorkplaceRequestsEnabled(workplaceRequestsFeatureFlag);

  if (!shouldShow) {
    return null;
  }

  if (!office) {
    return null;
  }

  const recurringValue = form.watch("recurring");
  const isRecurring =
    recurringValue && recurringValue !== "" && recurringValue !== "no";

  if (isRecurring) {
    return null;
  }

  // Pre-fill the request wizard's location from the currently selected resource,
  // mirroring how filing a request from a map resource works.
  const resourceContext: NewRequestResourceContext | undefined = currentResource
    ? {
        id: currentResource.id,
        name: currentResource.label || currentResource.name,
        officeId: currentResource.office_id || office.id,
        floorName: floors?.find((f) => f.id === currentResource.parent_id)
          ?.name,
        type: currentResource.type
      }
    : undefined;

  return (
    <div className="" onClick={(e) => e.stopPropagation()}>
      <WPRequests
        officeId={office.id}
        onSubmitRef={
          wpRequestsRef as React.MutableRefObject<
            WorkplaceRequestsRef | undefined
          >
        }
        className=""
        workplaceRequestItems={workplaceRequestItems}
        onBufferChange={setCurrentBufferSettings}
        resource={resourceContext}
        reservationWhen={
          reservationWhenFromReserveForm({
            weekDates: form.watch("weekDates"),
            time: form.watch("time"),
            duration: form.watch("duration")
          }) ?? undefined
        }
      />
    </div>
  );
};
